module.exports = __webpack_public_path__ + "img/soms_web_11.03a89d0a.png";